module.exports = __webpack_public_path__ + "static/pic1-5d0fbcf3bb97d09522f88143dfd92f0f.jpg";